import React from "react"
import { Box, Typography, Skeleton } from "@mui/material"
import { ReactComponent as PreviewTrustChat } from '../../../../assets/images/KnowledgeBase/preview-trustchat.svg'

export function PreviewNavbar({ brandColor, accentColor, logoPreview, businessName, viewMode = "web", fontFamily, loading }) {
    const isMobile = viewMode === "mobile";

    return (
        <Box
            sx={{
                backgroundColor: loading ? "#E5E9EC" : brandColor || "#148DFD",
                borderRadius: 1,
                p: isMobile ? 1.5 : 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pb: isMobile ? 2 : 3,
                fontFamily: fontFamily || "Inter",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                {loading ? (
                    <Skeleton variant="circular" width={16} height={16} />
                ) : logoPreview ? (
                    <Box
                        component="img"
                        src={logoPreview}
                        alt="Logo"
                        sx={{
                            width: isMobile ? 12 : 16,
                            height: isMobile ? 12 : 16,
                            objectFit: "cover",
                            borderRadius: "50%",
                            flexShrink: 0,
                            display: "block",
                        }}
                    />
                ) : (
                    <PreviewTrustChat style={isMobile ? { transform: 'scale(0.85)', transformOrigin: 'left center' } : {}} />
                )}
                {loading ? (
                    <Skeleton variant="text" width={100} height={20} />
                ) : (
                    <Typography
                        sx={{
                            color: "#FFF",
                            fontFamily: `${fontFamily || "Inter"} !important`,
                            fontSize: isMobile ? 11 : 15,
                            fontWeight: 400,
                            lineHeight: "19px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: isMobile ? 100 : 180,
                        }}
                    >
                        {businessName}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}
